import { Spinner } from '@gluestack-ui/themed'
import { StackScreenProps } from '@react-navigation/stack'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { StyleSheet } from 'react-native'
import { WebView } from 'react-native-webview'
import { getAuthToken } from '../../api/authMiddleware'
import { Content } from '../../components/NativeBaseLegacy'
import { LeftButtonBack, Page } from '../../components/Page'
import { env } from '../../environment'
import { i18n } from '../../lib/i18n'
import { ActionViewParamsType } from '../../navigation/Routes'
import { showDanger } from '../../services/toast'

export const SurveyPageForm: FunctionComponent<StackScreenProps<ActionViewParamsType, 'SurveyPageForm'>> = ({ route, navigation }) => {
  const { id, uuid, titre, title } = route.params
  const [authToken, setAuthToken] = useState<string>()

  const surveyId = id || uuid
  const surveyTitle = titre || title

  const surveyUrl = `${env().baseSurveyUrl}`

  /*
   * For testing in local use env().baseTestAndroidEmulatorSurveyUrl
   * Launch AC-Pages on your localHost
   * And yarn android AC-mobile
   */

  useEffect(() => {
    getAuthToken()
      .then(setAuthToken)
      .catch(() => {
        showDanger(i18n.t('toast.error'))
        navigation.goBack()
      })
  }, [])

  const INJECTED_JAVASCRIPT = `(function() {
    document.cookie = 'ac-token=${authToken}; path=/';
    return true;
  })()`

  return (
    <Page left={<LeftButtonBack />} title={surveyTitle || i18n.t('surveys.fallbackTitle')}>
      <Content style={styles.container}>
        {authToken ? (
          <WebView
            style={styles.webview}
            source={{ uri: `${surveyUrl}/${surveyId}`, headers: { AuthToken: authToken } }}
            javaScriptEnabled
            injectedJavaScriptBeforeContentLoaded={INJECTED_JAVASCRIPT}
            renderLoading={() => <Spinner />}
            cacheEnabled={false}
            sharedCookiesEnabled={true}
          />
        ) : (
          <Spinner />
        )}
      </Content>
    </Page>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  webview: {
    flex: 1,
  },
})
